export default __webpack_public_path__ + "static/depthCam-7aee756643812a06c83d92dce83a69f9.png";